var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"offer-benefit-badge"},[_c('div',{staticClass:"offer-benefit-badge__wrapper"},[_c('span',{staticClass:"offer-benefit-badge__text"},[_vm._v("\n      "+_vm._s(_vm.$t('offerOptionsBenefits.onlyWithAlao'))+"\n    ")]),_vm._v(" "),_c('AlaoLogoWhite',{staticClass:"offer-benefit-badge__logo"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }